var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M9.674 3L16 7.63l-6.326 4.63v-2.223C9.358 10.022 3.837 9.66 0 13c1.535-4.709 6.358-6.942 9.674-7.778V3z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("use",{"fill":"#1E2535","xlinkHref":"#a","key":1})])]);
}

Share.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Share;

Share.default = Share;
